import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-title-download',
  templateUrl: './title-download.component.html',
  styleUrls: ['./title-download.component.scss']
})
export class TitleDownloadComponent implements OnInit {

  titleForm: FormGroup;
  finalChain: string[];

  descriptions = [
    { labelId: 2, description: 'Clave oracle' },
    { labelId: 3, description: 'Proposito' },
    { labelId: 4, description: 'Titulo' }
  ];

  constructor(public activeModal: NgbActiveModal,
    private formBuilder: FormBuilder) { }

  ngOnInit() {

    this.titleForm = this.formBuilder.group({
      separator: [''],
      label: [''],
      chain: [''],
      height: [''],
      wide: ['']
    });

    this.finalChain = new Array();
  }

  returnData(): void {
    this.activeModal.close('Close click');
  }

  onCheckboxChange(option, event) {
    if (event.target.checked) {
      this.finalChain.push(option.description);
    } else {
      for (let i = 0; i < this.descriptions.length; i++) {
        if (this.finalChain[i] === option.description) {
          this.finalChain.splice(i, 1);
        }
      }
    }

    this.titleForm.patchValue({
      chain: this.finalChain
    });
  }

  toDownload(): void {

    this.activeModal.close(
      this.titleForm.value
    );

    // this.downloadObject = this.titleForm.getRawValue();
  }
}
